// Общие подписи таблиц «Планирования» (финансы и АКБ). Вынесены из
// PlanningPage 17.09.2026: их берут строки обеих таблиц, а страница сама
// импортирует эти таблицы — получался цикл импортов.

export function percent(plan: number, fact: number): string {
  if (plan <= 0) return '—'
  return `${Math.round((fact / plan) * 1000) / 10}%`
}

// Цвет % по выполнению плана. Условные пороги: красный <30%, жёлтый 30-70%,
// зелёный 70%+. Если плана нет — серый (нейтральный).
export function percentColorClass(plan: number, fact: number): string {
  if (plan <= 0) return 'text-gray-400'
  const ratio = fact / plan
  if (ratio < 0.3) return 'text-red-500 font-semibold'
  if (ratio < 0.7) return 'text-amber-500 font-semibold'
  return 'text-emerald-600 font-semibold'
}

// Дата последнего изменения факта — подпись под полем «Факт» (как у курсов валют).
export function formatFactDate(iso: string | null): string {
  if (!iso) return 'ещё не менялся'
  return new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const ROLE_LABELS: Record<string, string> = {
  MANAGER: 'Менеджер',
  ROP: 'РОП',
}

/** Подсказка у сумм за несколько месяцев — править их можно только помесячно. */
export const MULTI_MONTH_READONLY_TITLE =
  'Сумма за несколько месяцев. Чтобы изменить — выберите период «Месяц»'

/** Подсказка на ячейках плана у бухгалтера: он вносит только факт (этап 3, C2). */
export const PLAN_READONLY_TITLE = 'План задают администратор и РОП — бухгалтер вносит только факт'
